import { AgsBetBarValueText } from "ags/controls/ags-bet-bar-value-control";
import { Layers } from "appworks/graphics/layers/layers";
import { gameiomModel } from "gameiom/model/gameiom-model";
import { DisplayObject } from "pixi.js";
import { BetBarComponent } from "slotworks/components/betbar/bet-bar-component";

export class AgsBetBarComponent extends BetBarComponent {
    constructor() {
        super();
        Layers.get("MenusContent").onSceneEnter.add((scene: string) => this.onMenusContentSceneChange(scene));
    }

    protected initBetBarValues() {
        this.balanceValue = new AgsBetBarValueText(this.layer, "balance");
        this.totalWinValue = new AgsBetBarValueText(this.layer, "total_win", true);
        this.currentWinValue = new AgsBetBarValueText(this.layer, "current_win", true);
    }

    protected onMenusContentSceneChange(scene: string): void {
        if (gameiomModel.hideDenom && scene === "betsetting") {
            const menusContent = Layers.get("MenusContent");
            this.hideDenomSlider(menusContent);
        }
    }

    protected refresh(): void {
        super.refresh();

        if (gameiomModel.hideDenom) {
            this.hideDenomStepper();
        }

        if (gameiomModel.hideBet) {
            this.hideBet();
        }

        if (gameiomModel.hideBalance) {
            this.hideBalance();
        }

        // Make sure bg is blocking, so you can't click through to skip prompts etc
        const backing = Layers.get("BetBar").getSprite("bg");
        if (backing) { backing.interactive = true; }
    }

    protected hide(...objects: DisplayObject[]): void {
        objects.forEach((object) => {
            if (object != null) {
                object.visible = false;
            }
        });
    }

    protected hideBalance(): void {
        const prefix = gameiomModel.displayCurrency ? "balance_credits_" : "balance_currency_";
        this.hide(
            this.layer.getText(prefix + "label"),
            this.layer.getText(prefix + "value"),
        );
    }

    protected hideBet(): void {
        this.hide(
            //this.layer.getText("total_bet_label"),
            this.layer.getText(gameiomModel.displayCurrency ? "total_in_credits" : "total_stake")
        );
    }

    protected hideDenomSlider(layer: Layers): void {
        this.hide(
            layer.getText("credit_size_slider_label"),
            layer.getText("credit_size_slider_max_label"),
            layer.getText("credit_size_slider_min_label"),
            layer.getSprite("credit_size_slider_handle"),
            layer.getSprite("credit_size_slider_fill"),
            layer.getSprite("credit_size_slider_track"),
            layer.getText("denom_label"),
            layer.getShape("land_bg_1"),
        );
    }

    protected hideDenomStepper(): void {
        this.hide(
            this.layer.getText("DENOM"),
            this.layer.getText("credit_size_stepper_value"),
            this.layer.getButton("credit_size_stepper_up"),
            this.layer.getButton("credit_size_stepper_down"),
            this.layer.getSprite("credit_size_background"),
            this.layer.getSprite("credit_size_background_2"),
        );
    }
}
